import { Component, OnDestroy, OnInit } from '@angular/core';
import { StateComponent } from '../state-component.interface';
import { Usdm2Service } from '../../../../services/ai/usdm2.service';
import { Subscription } from 'rxjs';

type SingleDesignCellInput = {
  study_arm_uid: string;
  study_epoch_uid: string;
  study_element_uid: string;
};
type DesignCellsInput = {
  all_design_cells: SingleDesignCellInput[];
};

@Component({
  selector: 'app-design-cells',
  imports: [],
  templateUrl: './design-cells.component.html',
  styleUrl: './design-cells.component.css'
})
export class DesignCellsComponent implements StateComponent, OnInit, OnDestroy {
  stateName = 'Study Design Cells';
  private usdmSub: Subscription | null = null;
  data: DesignCellsInput | null = null;

  constructor(private usdm: Usdm2Service) { }

  ngOnInit(): void {
    this.usdmSub = this.usdm.contentUpdate$.subscribe((item) => {
      if (this.usdm.currentState() == this.stateName && item && item.type === 'FinishResponse') {
        this.data = item.result as DesignCellsInput;
        this.usdm.signalStateCompletion(this.stateName);
      }
    });
  }

  ngOnDestroy(): void {
    this.usdmSub?.unsubscribe();
    this.usdmSub = null;
  }
}
